import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../../service/service.js';
import {ElementUtil} from '../../../utils/elementUtil.js';
import {TimeUtil} from '../../../utils/timeUtil.js';
import {ExportUtil} from '../../../utils/exportUtil.js';
import {BaseComponent} from '../../basecomponent.js';


/* global customElements */
class WebhookGrid extends BaseComponent {

	//remember if the attribute is added it's true
	static get properties() {
		return {
			admin: {type: Boolean}
		};
	}
	
	constructor() {
		super();
		
		var webhookGrid = this;
		setTimeout(function(){
			webhookGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var webhookGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filtercompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;' + (webhookGrid.admin ? '' : 'display: none;'),
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					postinit: function(combo) {
						if (webhookGrid.admin) {
							Service.getCompanyService().getCompaniesLookup().then(function(data){
								combo.items = data;
							});
						}
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							var companyId = ElementUtil.query(toolbar, 'filtercompany').value;
							if (companyId) {
								ElementUtil.query(toolbar, 'add').disabled = false;
							} else {
								ElementUtil.query(toolbar, 'add').disabled = true;
							}							
							actionRefresh();
						}
					}					
				},
				{
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'view',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_API_RESTRICTION_POLICY:READ'],
					children:[
						ElementUtil.makeIcon('lumo:eye', ' View')
					],
					listeners: {
						click: function() {							
							viewAction(grid.selectedItems[0]);
						}
					}
				},				
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					disabled: true,	
					'class': 'spacer-toolbar-item',										
					permissions: ['ADMIN_API_RESTRICTION_POLICY:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							addEditAction();
						}
					}
				},				
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_API_RESTRICTION_POLICY:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							addEditAction(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'updatestatus',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_API_RESTRICTION_POLICY:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Toggle Status')
					],
					listeners: {
						click: function() {							
							actionActivateDisable(grid.selectedItems[0]);
						}
					}					
				},			
				{
					tag: 'dl-action-button',						
					theme: 'error primary',
					itemid: 'delete',
					disabled: true,
					'class': 'spacer-toolbar-item',
					style: 'float: right;' + (webhookGrid.admin ? 'margin-top: 18px;' : ''),
					permissions: ['ADMIN_API_RESTRICTION_POLICY:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},
			children: [				
				{						
					path: 'companyName',
					header: 'Company Name',
					width: '5em'						
				},
				{						
					path: 'webhookTypeDescription',
					header: 'Type',
					width: '5em'						
				},
				{						
					path: 'authTypeDescription',
					header: 'Auth Type',
					width: '5em'
				},				
				{						
					path: 'callBackUrl',
					header: 'Callback URL',
					width: '5em'
				},							
				{						
					path: 'numberOfSuccesses',
					header: 'Successes',					
					'text-align': 'center',
					width: '5em'
				},
				{
					path: 'numberOfFailsSinceLastSuccess',
					header: 'Fails Since Success',					
					'text-align': 'center',
					width: '5em'
				},	
				{
					path: 'permanent',
					header: 'Permanent',					
					'text-align': 'center',
					width: '5em'
				},
				{
					path: 'createUser',
					header: 'Create User',										
					width: '5em'
				},
				{
					path: 'activeStatus',
					header: 'Active Status',					
					'text-align': 'center',
					width: '5em'
				}	
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'view').disabled = false;
						ElementUtil.query(toolbar, 'updatestatus').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false; 						
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'view').disabled = true;
						ElementUtil.query(toolbar, 'updatestatus').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true; 
					}	
				}
			}
		});
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					webhookGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'updateDts',
						sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'DESC',
						status: ElementUtil.query(toolbar, 'status').value
					};
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
						
						webhookGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					if (webhookGrid.admin) {
						var companyId = ElementUtil.query(toolbar, 'filtercompany').value;
						if (companyId) {
							webhookGrid.currentFilter.companyId = companyId;
							Service.getApiService().getWebhooks(webhookGrid.currentFilter).then(function(records){
								successHandler(records);
							});
						} else {
							loadMask.remove();
						}
					} else {
						Service.getApiService().getWebhooks(webhookGrid.currentFilter).then(function(records){						
							successHandler(records);
						});
					}					
										
				};
			}
			
		});	
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				var exportFilter = Object.assign({}, webhookGrid.currentFilter || {});
				delete exportFilter.offset;
				delete exportFilter.max;
				Service.getApiService().exportWebhooks(exportFilter);
			}
		});
		
		var gridLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		webhookGrid.append(gridLayout);
		
		
		//hide admin only options
		if (!webhookGrid.admin) {
			//make sure it's rendered
			setTimeout(function(){
				ElementUtil.query(toolbar, 'filtercompany').classList.add('hide');			
			}, 10);
			ElementUtil.query(toolbar, 'add').disabled = false;
		}
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};
		actionRefresh();
	
		var actionDelete = function(record) {
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete webhook <b>' + record.webHookId + '</b>? <br><br> This may impacted external integrations.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting webhook...');													
							
							Service.getApiService().deleteWebhooks(record.webHookId).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted webhook: ' + record.webHookId, {									
									theme: 'success'
								});
								actionRefresh();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});
		};		
		
		var addEditAction = function(record) {
			
			var companyId = ElementUtil.query(toolbar, 'filtercompany').value;
			var addEditWin = ElementUtil.create({
					tag: 'dl-dialog',
					title: (record ? 'Edit Webhook' : 'Add Webhook'),
					icon: 'vaadin:edit',
					listeners: {
						ready: function() {						
							addEditWin.show();

							var loadMask = addEditWin.showLoading();
							var authTypeMap = {};
							var authTypes;
							
							Service.getLookupService().getLookupValues('WebhookAuthType').then(function(data){
								loadMask.remove();
								
								data.forEach(function(authType) {
									authTypeMap[authType.code] = authType;
								});
								authTypes = data;								
								proceedWithForm();
							});

							var proceedWithForm = function () {
								var formPanel = ElementUtil.create({
									tag: 'dl-form-panel',
									itemid: 'form',
									children: [
										{
											tag: 'vaadin-form-layout',
											children: [
												{
													tag: 'vaadin-combo-box',
													label: 'Webhook Type',
													name: 'webhookType',
													'item-value-path': 'code',
													'item-label-path': 'description',
													required: true,
													postinit: function (combo) {
														Service.getLookupService().getLookupValues('WebhookType').then(function (data) {
															combo.items = data;
														});
													}
												},
												{
													tag: 'vaadin-combo-box',
													itemId: 'authType',
													label: 'Auth Type',
													name: 'authType',
													'item-value-path': 'code',
													'item-label-path': 'description',													
													postinit: function (combo) {														
														combo.items = authTypes;
														combo.required = true;
													},
													listeners: {
														change: function () {
															var authType = ElementUtil.query(formPanel, 'authType').value;
															actionShowOptions(authType);
														}
													}
												},
												{
													tag: 'vaadin-text-field',
													name: 'callBackUrl',
													label: 'Callback URL',
													required: true,
													maxlength: 120
												},
												{
													tag: 'vaadin-number-field',
													name: 'runsToKeep',
													label: 'Runs to Keep',
													required: true,
													min: 1,
													max: 10
												},
												{
													tag: 'vaadin-text-field',
													name: 'userData',
													label: 'User Data',
													'helper-text': 'Custom Data to be passed back to the user',
													maxlength: 255
												},
												{
													tag: 'vaadin-text-field',
													name: 'watchEntityId',
													label: 'Watch Entity Id',
													maxlength: 255
												},
												{
													tag: 'vaadin-checkbox',
													name: 'permanent',
													label: 'Permanent'
												}
											]
										},
										{
											tag: 'fieldset',
											colspan: 2,
											children: [
												{
													tag: 'legend',													
													innerHTML: 'Auth Options'
												},
												{
													tag: 'vaadin-form-layout',
													itemId: 'optionPanel',
													children: [
													]
												}
											]
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function () {


															formPanel.submitForm({
																preSubmit: function (data) {

																	//unpack options
																	var options = {};
																	for (var key in data) {
																		if (key.startsWith('option-')) {
																			var optionKey = key.replace('option-', '');
																			options[optionKey] = data[key];
																		}
																	}
																	data.options = options;

																	return data;
																},
																actualCall: function (data) {
																	if (companyId) {
																		data.companyId = companyId;
																	}
																	if (record) {
																		data.webHookId = record.webHookId;
																	}
																	return Service.getApiService().saveWebhooks(data, (record ? true : false));
																},
																success: function (data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Added a webhook', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function () {
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								});

								addEditWin.addToContentElement(formPanel);

								var actionShowOptions = function (authType, existingData) {
									var data = existingData || {};									

									var optionPanel = ElementUtil.query(formPanel, 'optionPanel');
									ElementUtil.removeAllChildren(optionPanel);

									var authTypeFull = authTypeMap[authType];
									
									var fields = [];
									authTypeFull.requiredOptions.forEach(function(option){
										
										fields.push(
											ElementUtil.create({
												tag: 'vaadin-text-field',
												name: 'option-' + option ,
												label: option,
												value: (data[option] ? data[option] : ''),
												maxlength: 255
											})
										);
									});
									ElementUtil.addElements(optionPanel, fields);									
								};

								if (record) {
									formPanel.load(record);
																		
									setTimeout(function(){
										var authField = ElementUtil.query(formPanel, 'authType');
										authField.focus();
										authField.blur();
										
										//load options
										actionShowOptions(record.authType, record.options);
									}, 50);
									
								}


							};
						
						}
					}
				});
				
				
		};
		
		
		var actionActivateDisable = function(record) {
			
			if (record.activeStatus !== 'A') {
				var loadMask = grid.showLoading('Activate Webhook...');
				Service.getApiService().activateWebhooks(record.webHookId).then(function(){
					loadMask.remove();

					window.DL.MessageUtil.showToast('Success', 'Activated Webhook: ' + record.webHookId, {									
						theme: 'success'
					});
					actionRefresh();
				});
			} else {
				var loadMask = grid.showLoading('Inactive Webhook...');
				Service.getApiService().inactivateWebhooks(record.webHookId).then(function(){
					loadMask.remove();

					window.DL.MessageUtil.showToast('Success', 'Inactivated Webhook: ' + record.webHookId, {									
						theme: 'success'
					});
					actionRefresh();
				});				
			}
		};
	
		var viewAction = function(record) {
			
			var viewWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'View Webhook',
				icon: 'lumo:eye',
				listeners: {
					ready: function() {
						
						viewWin.show();
						
						var getDetails = function(inputRecord) {
							var date = TimeUtil.parseDate(inputRecord.webhookView.updateDts);						
							var formatedDate =  TimeUtil.formatDateStandard(date);
							var detailData = [
								{
									key: 'Web Hook Id',
									value: inputRecord.webhookView.webHookId
								},
								{
									key: 'Company Id',
									value: inputRecord.webhookView.companyId
								},
								{
									key: 'Company Name',
									value: inputRecord.webhookView.companyName
								},
								{
									key: 'Type',
									value: inputRecord.webhookView.webhookTypeDescription
								},
								{
									key: 'Auth Type',
									value: inputRecord.webhookView.authTypeDescription
								},
								{
									key: 'Watch Entity Id',
									value: inputRecord.webhookView.watchEntityId
								},
								{
									key: 'Callback URL',
									value: inputRecord.webhookView.callBackUrl
								},
								{
									key: 'Permanent',
									value: inputRecord.webhookView.permanent
								},
								{
									key: 'Number Successes',
									value: inputRecord.webhookView.numberOfSuccesses
								},
								{
									key: 'Fails Since Last Success',
									value: inputRecord.webhookView.numberOfFailsSinceLastSuccess
								},								
								{
									key: 'Runs To Keep',
									value: inputRecord.webhookView.runsToKeep
								},								
								{
									key: 'User Data',
									value: inputRecord.webhookView.userData
								},																
								{
									key: 'Update User',
									value: inputRecord.webhookView.updateUser
								},								
								{
									key: 'Update Date',
									value: formatedDate
								}
							];
							
							//options
							if (inputRecord.webhookView.options) {
								detailData.push({
									key: 'Options',
									value: '-',
									section: true
								});
								
								for (var key in inputRecord.webhookView.options) {
									detailData.push({
										key: key,
										value: inputRecord.webhookView.options[key]
									});
								} 
							}
							
							//response
							if (inputRecord.responses && inputRecord.responses.length > 0) {
								detailData.push({
									key: 'Responses',
									value: '-',
									section: true
								});
								
								inputRecord.responses.forEach(function(item){
									detailData.push({
										key: 'Trigger Time',
										value: TimeUtil.formatDateStandard((TimeUtil.parseDate(item.triggerTime)))
									});
									detailData.push({
										key: 'Entity Id',
										value: item.entityId
									});
									detailData.push({
										key: 'Message',
										value: item.message
									});
									detailData.push({
										key: 'User Data',
										value: item.userData
									});
									detailData.push({
										key: 'External Call Successful',
										value: item.externalCallSuccessful
									});
									detailData.push({
										key: 'External Response Code',
										value: item.externalResponseCode
									});
									detailData.push({
										key: 'External Response',
										value: item.externalResponse
									});
									detailData.push({
										key: '-------',
										value: '------'										
									});
								});
						
							}
							
							return detailData;
						};
						
						var details = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								{
									tag: 'div',								
									slot: 'primary',
									children: [
										{
											tag: 'dl-detail-table',
											itemid: 'table',
											style: ''											
										}
									]
								},
								{
									tag: 'dl-nextprev-toolbar',	
									itemid: 'nextPrev',
									slot: 'footer',
									listeners: {
										ready: function(event){
											event.target.updateData(webhookGrid.fullDataSet);
											event.target.setSelectedRecord('trackingId', record.trackingId);
										},
										change: function(event) {
											grid.deselectItem(record);
											grid.selectItem(event.detail.item);
											record = event.detail.item;
											
											loadDetails(record);					
										}										
									}
								}
							]
						});
						viewWin.addToContentElement(details);
						
						var loadDetails = function(loadRecord) {
							var loadMask = details.showLoading();
							Service.getApiService().getWebhookDetails(loadRecord.webHookId).then(function(webHookDetails){
								loadMask.remove();
								ElementUtil.query(details, 'table').updateDetails(getDetails(webHookDetails));														
							}).catch(function() {
								loadMask.remove();
							});
						};							
						loadDetails(record);
						
					}
				}
			});			
		};
		
	}
	
};
customElements.define('dl-webhook-grid', WebhookGrid);
